interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    pages.push(i);
  }

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md border text-sm font-medium transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${baseBtn} border-background-300 px-3 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${baseBtn} ${
            page === current
              ? "border-primary-700 bg-primary-700 text-background-50"
              : "border-background-300 text-foreground-600 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${baseBtn} border-background-300 px-3 text-foreground-600 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}